export interface Newbox_data {
    id : number;

    imgurl : string;

    title : string;

    font? : string;

    persent : string;

    saleprice : string;

    price : string;

    review? : string;
}

let newbox_data:Newbox_data[] = [
    {
        id : 0,

        imgurl : './img/new/img0.jpg',
        
        title : '마시멜로 데님 크로스백 1종 JNBG7675',

        font : '',

        persent : '24%',

        saleprice : '59,800원',

        price : '78,900원',

        review : '',
    },
    {
        id : 1,

        imgurl : './img/new/img1.jpg',
        
        title : '썬플라워 반팔티셔츠 올드핑크 MJST7672',

        font : '',

        persent : '28%',

        saleprice : '39,000원',

        price : '27,900원',

        review : 'REVIEW : 1',
    },
    {
        id : 2,

        imgurl : './img/new/img2.jpg',
        
        title : '써머 라우드 데님 반팔셔츠 빈티지블루 MJSS7663',

        font : '',

        persent : '14%',

        saleprice : '49,000원',

        price : '41,900원',

        review : 'REVIEW : 1',
    },
    {
        id : 3,

        imgurl : './img/new/img3.jpg',
        
        title : '포티 카라 반팔티셔츠 화이트오트밀 MJST7664',

        font : '',

        persent : '24%',

        saleprice : '34,900원',

        price : '45,900원',

        review : '',
    },
    {
        id : 4,

        imgurl : './img/new/img4.jpg',
        
        title : '드림플라워 반팔티셔츠 버건디 MJST7667',

        font : '',

        persent : '24%',

        saleprice : '27,900원',

        price : '36,900원',

        review : '',
    },
    {
        id : 5,

        imgurl : './img/new/img5.jpg',
        
        title : '플랜트 시드 반팔티셔츠 블랙 JIST7661',

        font : '[6/14 예약배송]',

        persent : '29%',

        saleprice : '26,900원',

        price : '38,000원',

        review : '',
    },
    {
        id : 6,

        imgurl : './img/new/img6.jpg',
        
        title : '플랜트 시드 반팔티셔츠 오트밀 JIST7661',

        font : '[6/14 예약배송]',

        persent : '29%',

        saleprice : '26,900원',

        price : '38,000원',

        review : '',
    },
    {
        id : 7,

        imgurl : './img/new/img7.jpg',
        
        title : '문 어라운드 반팔티셔츠 블랙 MJST7657',

        font : '',

        persent : '26%',

        saleprice : '25,900원',

        price : '35,000원',

        review : 'REVIEW : 3',
    },
    {
        id : 8,

        imgurl : './img/new/img8.jpg',
        
        title : '문 어라운드 반팔티셔츠 라이트베이지 MJST7657',

        font : '',

        persent : '26%',

        saleprice : '25,900원',

        price : '35,000원',

        review : 'REVIEW : 1',
    },
    {
        id : 9,

        imgurl : './img/new/img9.jpg',
        
        title : '더틴 워싱 데님펜츠 블루 MJLP7674',

        font : '',

        persent : '17%',

        saleprice : '45,900원',

        price : '55,000원',

        review : '',
    },
    {
        id : 10,

        imgurl : './img/new/img10.jpg',
        
        title : '[패키지] 져니홈+어뉴+투두 반팔티셔츠 2PACK (MJST7662+MJSU7665+MJST7660)',

        font : '[6/8 예약배송]',

        persent : '44%',

        saleprice : '38,900원',

        price : '69,000원',

        review : 'REVIEW : 1',
    },
    {
        id : 11,

        imgurl : './img/new/img11.jpg',
        
        title : '어뉴 반팔티셔츠 화이트 MJST7662',

        font : '[6/8 예약배송]',

        persent : '26%',

        saleprice : '25,900원',

        price : '34,900원',

        review : '',
    },
]

export default newbox_data;